import { render, staticRenderFns } from "./RegimenReview.vue?vue&type=template&id=25d51044"
import script from "./RegimenReview.vue?vue&type=script&lang=js"
export * from "./RegimenReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports